import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import imageCompression from "browser-image-compression";
import { hasRole } from "../../util/utilFunction";

const hit = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT_LMS,
});

const API = process.env.REACT_APP_ENDPOINT_LMS;

const compressImage = async (file) => {
  try {
    return await imageCompression(file, {
      maxSizeMB: 0.7,
      maxWidthOrHeight: 1280,
      useWebWorker: true,
      fileType: "image/jpeg",
      initialQuality: 0.8,
    });
  } catch (err) {
    console.error("compress error:", err);
    return file;
  }
};

const uploadToR2 = async (file, folder) => {
  const compressed = await compressImage(file);

  const formData = new FormData();
  formData.append("file", compressed, file.name);

  const res = await fetch(`${API}/upload-to-r2?folder=${folder}`, {
    method: "POST",
    body: formData,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    // response bukan JSON
  }

  if (!res.ok || !data?.key) {
    throw new Error(
      data?.error || `Upload ${folder} gagal (status ${res.status})`
    );
  }

  return data;
};

export const useSuggestionSystem = () => {
  const user = JSON.parse(localStorage.getItem("auth"));

  const [menu, setMenu] = useState("suggestion-system");

  const [fileBefore, setFileBefore] = useState(null);
  const [fileAfter, setFileAfter] = useState(null);

  const [imgBefore, setImgBefore] = useState("");
  const [imgAfter, setImgAfter] = useState("");

  const [idePerbaikan, setIdePerbaikan] = useState("");
  const [tujuanPerbaikan, setTujuanPerbaikan] = useState("");
  const [status, setStatus] = useState("");

  const [images, setImages] = useState([]);
  const [listCariOrang, setListCariOrang] = useState([]);

  const [subMenu, setSubMenu] = useState("Riwayat");
  const [loading, setLoading] = useState(false);

  const [filterBulan, setFilterBulan] = useState();
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [isReload, setIsReload] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);

  const [subMenuRiwayat, setSubMenuRiwayat] = useState("review");
  const [headerReview, setHeaderReview] = useState();
  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
  });

  const [popUpCariNama, setPopUpCariNama] = useState(false);

  const [filterFrom, setFilterFrom] = useState();
  const [filterUntil, setFilterUntil] = useState();
  const [listUser, setListUser] = useState([]);
  const [userPick, setUserPick] = useState();
  const [searchData, setSearchData] = useState([]);
  const [search, setSearch] = useState("");

  const loadImage = async () => {
    const filterDate = filterBulan
      ? `${filterTahun}-${("0" + filterBulan).slice(-2)}`
      : `${filterTahun}`;

    try {
      const res = await hit.post("/images/user", {
        tim: user.tim,
        userId: user.id,
        type: hasRole(
          user,
          "super_user",
          "hrd_admin",
          "produksi_leader",
          "warehouse_admin",
          "ppic_admin",
          "qc_admin",
          "sp_admin",
          "mesin_admin",
          "mold_admin",
          "pr_admin"
        )
          ? "leader"
          : "operator",
        menu: subMenuRiwayat,
        filterDate: filterDate,
      });

      const data = res.data.data || [];

      const mapped = data.map((item) => ({
        formId: item.formId,
        idePerbaikan: item.idePerbaikan,
        tujuanPerbaikan: item.tujuanPerbaikan,
        status: item.status,
        timestamp: item.timestamp,
        name: item.name,
        isApprove: item.isApprove,
        checklistLeader: item.checklistLeader,
        komentarLeader: item.komentarLeader,
        isPenilai: item.isPenilai,
        penilai: item.penilai,
        timestampPenilai: item.timestampPenilai,
        approverKepala: item.approverKepala,
        checklistTimestamp: item.checklistTimestamp,
        komentarPenilai: item.komentarPenilai,
        kategori: item.kategori,
        kepalaShift: item.kepalaShift,
        bagian: item.bagian,
        q: item.q,
        c: item.c,
        d: item.d,
        s_k3: item.s_k3,
        s_lingkungan: item.s_lingkungan,
        m: item.m,

        imageBefore: `${
          process.env.REACT_APP_ENDPOINT_LMS
        }/image-proxy/${encodeURIComponent(item.image_before)}`,

        imageAfter: `${
          process.env.REACT_APP_ENDPOINT_LMS
        }/image-proxy/${encodeURIComponent(item.image_after)}`,
      }));

      setImages(mapped);
    } catch (err) {
      console.error("loadImage error:", err);
    }
  };

  const cariOrang = async () => {
    try {
      const res = await hit.post("/images/user", {
        tim: user.tim,
        type: "monitoring",
        userId: userPick.value,
        filterFrom: filterFrom,
        filterUntil: filterUntil,
      });

      const data = res.data.data || [];

      const mapped = data.map((item) => ({
        formId: item.formId,
        idePerbaikan: item.idePerbaikan,
        tujuanPerbaikan: item.tujuanPerbaikan,
        status: item.status,
        timestamp: item.timestamp,
        name: item.name,
        isApprove: item.isApprove,
        checklistLeader: item.checklistLeader,
        komentarLeader: item.komentarLeader,
        isPenilai: item.isPenilai,
        penilai: item.penilai,
        timestampPenilai: item.timestampPenilai,
        approverKepala: item.approverKepala,
        checklistTimestamp: item.checklistTimestamp,
        komentarPenilai: item.komentarPenilai,
        kategori: item.kategori,
        kepalaShift: item.kepalaShift,
        q: item.q,
        c: item.c,
        d: item.d,
        s_k3: item.s_k3,
        s_lingkungan: item.s_lingkungan,
        m: item.m,
        bagian: item.bagian,

        imageBefore: `${
          process.env.REACT_APP_ENDPOINT_LMS
        }/image-proxy/${encodeURIComponent(item.image_before)}`,

        imageAfter: `${
          process.env.REACT_APP_ENDPOINT_LMS
        }/image-proxy/${encodeURIComponent(item.image_after)}`,
      }));

      setListCariOrang(mapped);
    } catch (err) {
      console.error("loadImage error:", err);
    }
  };

  const handleGetChart = async () => {
    const res = await hit.post(
      "/getChartSuggestionSystem",
      {
        tim: user.tim,
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
      },
      {
        headers: {
          Authorization: `Bearer ${user.auth}`,
        },
      }
    );

    const data = res.data.data || {};

    setChartData(data);
  };

  useEffect(() => {
    if (subMenu === "Riwayat") {
      loadImage();
      setIsReload(false);
    }
  }, [subMenu, filterBulan, filterTahun, isReload, subMenuRiwayat]);

  const handleGetHeader = async () => {
    const res = await hit.post(
      "/getHearderSuggestionSystem",
      {
        tim: user.tim,
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
        filterBulanSebelumnya: moment(
          `${filterTahun}-${("0" + filterBulan).slice(-2)}`
        )
          .add(-1, "months")
          .format("YYYY-MM"),
      },
      {
        headers: {
          Authorization: `Bearer ${user.auth}`,
        },
      }
    );

    const data = res.data.data || {};

    setHeaderReview(data);
  };

  useEffect(() => {
    handleGetHeader();
  }, [subMenu, isReload]);

  const getUser = async () => {
    const res = await hit.post(
      "/getUser",
      {
        tim: user.tim,
      },
      {
        headers: {
          Authorization: `Bearer ${user.auth}`,
        },
      }
    );

    const data = res.data.data || {};

    setListUser(data);
  };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    setSearchData(images);
  }, [images]);

  const handleBefore = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileBefore(file);
    setImgBefore(URL.createObjectURL(file));
  };

  const handleAfter = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileAfter(file);
    setImgAfter(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    try {
      if (!fileBefore || !fileAfter || !status || status === "Pilih") {
        alert("File atau status belum lengkap");
        return;
      }

      setLoading(true);

      // upload BEFORE
      const beforeRes = await uploadToR2(fileBefore, "before");

      // upload AFTER
      const afterRes = await uploadToR2(fileAfter, "after");

      const payload = {
        tim: user.tim,
        formId: crypto.randomUUID(),
        userId: user.id,
        image_before: beforeRes.key,
        image_after: afterRes.key,
        idePerbaikan,
        tujuanPerbaikan,
        status,
      };

      const res = await fetch(`${API}/uploadSuggestionSystem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.success) {
        setIdePerbaikan("");
        setTujuanPerbaikan("");
        setImgBefore("");
        setImgAfter("");
        setStatus("");
        setFileBefore(null);
        setFileAfter(null);
        alert("Upload sukses");
      } else {
        alert("Upload gagal: data tidak tersimpan");
      }
    } catch (err) {
      console.error("upload error:", err);
      alert(`Upload gagal: ${err.message}`);
    } finally {
      setLoading(false);
      setIsDisabled(false); // selalu buka lagi tombolnya
    }
  };

  const handleKirimLeader = async (formId) => {
    const result = images.filter(
      (item) =>
        item.isEditLeader ||
        item.isEditPenilai ||
        item.isEditChecklist ||
        item.isEditQcdsm ||
        item.isEditKategori
    );

    const res = await hit.post(
      "/approveLeaderSS",
      {
        formId: formId,
        approverKepala: user.name,
        dataLeader: result[0],
      },
      {
        headers: {
          Authorization: `Bearer ${user.auth}`,
        },
      }
    );
    if (res.data.success) {
      setIsReload(true);
    }
  };

  const handleDelete = async (formId) => {
    try {
      const res = await hit.delete("/deleteSuggestionSystem", {
        data: { formId: formId },
        headers: {
          Authorization: `Bearer ${user.auth}`,
        },
      });
      if (res.data.success) {
        setIsReload(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeKomentar = (id, event, type) => {
    const updatedList = images.map((item) => {
      if (item.formId === id) {
        return {
          ...item,
          [event.target.name]: event.target.value,
          [`isEdit${type}`]: true,
        };
      }
      return item;
    });
    setImages(updatedList);
  };

  const handleChangeChecklist = (id, value) => {
    const updatedList = images.map((item) => {
      if (item.formId === id) {
        return {
          ...item,
          checklistLeader: value,
          [`isEditChecklist`]: true,
        };
      }
      return item;
    });
    setImages(updatedList);
  };

  const handleChangeKategori = (id, event) => {
    const updatedList = images.map((item) => {
      if (item.formId === id) {
        return {
          ...item,
          kategori: event.target.value,
          [`isEditKategori`]: true,
        };
      }
      return item;
    });
    setImages(updatedList);
  };

  const handleChangeQcdsm = (id, event) => {
    const updatedList = images.map((item) => {
      if (item.formId === id) {
        return {
          ...item,
          [event.target.name]: event.target.value.toUpperCase(),
          [`isEditQcdsm`]: true,
        };
      }
      return item;
    });
    setImages(updatedList);
  };

  const fields = ["idePerbaikan", "tujuanPerbaikan", "name", "kepalaShift"];

  const handleSearch = (keyword) => {
    if (!keyword || keyword.trim() === "") {
      setSearchData(images);
      return;
    }

    const lowerKeyword = keyword.toLowerCase();

    const filtered = images.filter((item) =>
      fields.some((field) => item[field]?.toLowerCase().includes(lowerKeyword))
    );

    setSearchData(filtered);
  };

  const handleExportBulananBpb = () => {
    let data = images && images;

    const filteredDataExcel = data.map((obj, index) => {
      return {
        "No.": index + 1,
        Tgl: moment(obj.timestamp).utcOffset("+0700").format("DD-MM-YY"),
        Jam: moment(obj.timestamp).utcOffset("+0700").format("HH:mm:ss"),
        Name: obj.name,
        "Ide Perbaikan": obj.idePerbaikan,
        "Tujuan Perbaikan": obj.tujuanPerbaikan,
        Bagian: obj.bagian,
        Kepala: obj.kepalaShift,
        Status: obj.checklistLeader,
      };
    });

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel
    );

    workSheet["!cols"] = [
      { wch: 4 },
      { wch: 9 },
      { wch: 9 },
      { wch: 40 },
      { wch: 45 },
      { wch: 45 },
      { wch: 20 },
      { wch: 14 },
      { wch: 9 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Barang Jadi");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `Data SS ${("0" + filterBulan).slice(
        -2
      )} - ${filterTahun} ${subMenuRiwayat.toUpperCase()}.xlsx`
    );
  };

  return {
    user,
    handleBefore,
    handleAfter,
    handleUpload,
    imgBefore,
    imgAfter,
    idePerbaikan,
    setIdePerbaikan,
    tujuanPerbaikan,
    setTujuanPerbaikan,
    status,
    setStatus,
    subMenu,
    setSubMenu,
    loading,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    handleKirimLeader,
    handleDelete,
    isDisabled,
    setIsDisabled,
    menu,
    setMenu,
    handleChangeKomentar,
    handleChangeChecklist,
    handleChangeQcdsm,
    subMenuRiwayat,
    setSubMenuRiwayat,
    headerReview,
    handleChangeKategori,
    chartData,
    popUpCariNama,
    setPopUpCariNama,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    listUser,
    userPick,
    setUserPick,
    cariOrang,
    listCariOrang,
    setListCariOrang,
    setSearch,
    search,
    handleSearch,
    searchData,
    handleExportBulananBpb,
    images,
  };
};
